import { useState } from 'react';

import { breakdownLabel, formatCount, formatMoney } from '../../../utils/salesReportUtils';

const KINDS = [
    { id: 'company', label: 'Empresa' },
    { id: 'paymentMethod', label: 'Pago' },
    { id: 'orderStatus', label: 'Estado' },
    { id: 'city', label: 'Ciudad' },
    { id: 'state', label: 'Provincia' },
    { id: 'discountCode', label: 'Cupón' },
];

const canSelect = (kind, row, basis) => Boolean(row?.key)
    && row.key !== 'other'
    && row.key !== 'Unknown'
    && !(kind === 'orderStatus' && basis === 'invoiced');

const patchFor = (kind, row) => {
    if (kind === 'company') return { ruc: [row.ruc || row.key] };
    if (kind === 'paymentMethod') return { paymentMethod: [row.key] };
    if (kind === 'orderStatus') return { orderStatus: [row.key] };
    if (kind === 'city') return { city: row.key };
    if (kind === 'state') return { state: row.key };
    if (kind === 'discountCode') return { discountCode: row.key };
    return null;
};

const SalesReportBreakdowns = ({ breakdowns = {}, basis = 'paid', onSelect }) => {
    const available = KINDS.filter((kind) => Array.isArray(breakdowns[kind.id]));
    const [kind, setKind] = useState(available[0]?.id || 'company');
    const activeKind = available.some((item) => item.id === kind) ? kind : available[0]?.id;
    const rows = breakdowns[activeKind] || [];
    const peak = Math.max(...rows.map((row) => Number(row.netSales) || 0), 0);

    return (
        <section className="sr-break-card" aria-label="Desgloses">
            <div className="sr-section-head">
                <div>
                    <h2>Desglose</h2>
                    <p className="sr-hint mb-0">Elige una fila para filtrar el reporte. Otros y sin dato no se pueden aplicar.</p>
                </div>
            </div>
            <div className="sr-break-layout">
                <div className="sr-break-navs" role="tablist" aria-label="Tipo de desglose">
                    {available.map((item) => (
                        <button
                            key={item.id}
                            type="button"
                            role="tab"
                            aria-selected={item.id === activeKind}
                            className={`sr-break-nav${item.id === activeKind ? ' is-active' : ''}`}
                            onClick={() => setKind(item.id)}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
                <div>
                    {!rows.length && <p className="sr-empty mb-0">No hay datos para este desglose.</p>}
                    {rows.map((row) => {
                        const selectable = canSelect(activeKind, row, basis);
                        const width = peak > 0 ? Math.max((Number(row.netSales) || 0) / peak, 0) * 100 : 0;
                        return (
                            <button
                                key={`${activeKind}-${row.key}`}
                                type="button"
                                className="sr-break-row"
                                disabled={!selectable}
                                onClick={() => {
                                    const patch = patchFor(activeKind, row);
                                    if (patch) onSelect(patch);
                                }}
                            >
                                <span className="sr-break-label">{breakdownLabel(row, activeKind)}</span>
                                <span className="sr-break-money">{formatMoney(row.netSales)}</span>
                                <span className="sr-bar" aria-hidden="true">
                                    <span style={{ width: `${width}%` }} />
                                </span>
                                <span className="sr-break-meta">
                                    {formatCount(row.orderCount)} pedidos · {formatCount(row.unitsSold)} uds
                                    {row.discountTotal ? ` · desc. ${formatMoney(row.discountTotal)}` : ''}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default SalesReportBreakdowns;
